import React from "react";
import CotizacionDetailPage from "../component/Cotizacion/CotizacionDetailPage";

const CotizacionVer = () => <CotizacionDetailPage />;

export default CotizacionVer;
